export default __webpack_public_path__ + "static/2308-dad8ed6d3b3a7a529361ada39bae95dc.gif";